$(function() {
  if($('#PBarNextFrameWrapper').length){
    $('body').addClass('PBarNextFrameWrapper');
  }else{
    $('body').removeClass('PBarNextFrameWrapper');
  }
});

//加入购物车
$(function() {
  
  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      fetch(window.Shopify.routes.root + '?sections=cart-drawer')
        .then(response => response.json())
        .then(responseText => {
          fetch(window.Shopify.routes.root + 'cart.js', {
            method: 'get',
            headers: {
              'Content-Type': 'application/json'
            },
          })
          .then(response => response.json())
          .then(data => {
            const html = '<div class="cart-count-bubble"><span aria-hidden="true">'+ data.item_count +'</span><span class="visually-hidden">'+ data.item_count +' item</span></div>';
            if ($('#cart-icon-bubble cart-count-bubble').length) {
                $('#cart-icon-bubble').html(html);
            } else {
               $('#cart-icon-bubble').append(html);
            }
          }).catch(error => {
            console.error('Error:', error)
          });
          
          const html = new DOMParser().parseFromString(responseText['cart-drawer'], 'text/html');
          const $parsed = $(html);
          $('.js-cart-drawer').replaceWith($parsed.find('#shopify-section-cart-drawer').children());
          setTimeout(function(){ 
            $('cart-drawer').addClass('animate active');
          }, 200);
        });
    }
  }

  $(document).on('submit', '.js-add-to-cart-form', function(event) {
    // 阻止表单默认提交行为
    event.preventDefault();

    $(this).find("button[type='submit']").addClass('loading').prop("disabled",true);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: $(this).find("input[name='id']").val(),
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      openCartDrawer();
      $(this).find("button[type='submit']").removeClass('loading').prop("disabled",false);
    }).catch(error => {
      console.error('Error:', error);
      $(this).find("button[type='submit']").removeClass('loading').prop("disabled",false);
    });
  });
});